import { DateTime } from 'luxon';
import axios from 'smg/axios';
import * as countries from 'smg/countries';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as models from 'smg/models';
import { Human } from 'smg/phone';
import { Relref } from '../hugo';

export default async function main() {
    const $spinner = document.querySelector('#overview-spinner') as HTMLElement;
    const $content = document.querySelector('#overview-container') as HTMLElement;

    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const sess = session.Session();

    // const pl: PageLoader<models.Order> = new PageLoader<models.Order>({
    //     get: () => axios.get<hyejoo.Orders>('/orders', {
    //         params: {
    //             'sort': pl.Sort(),
    //             'max': 1,
    //             'data': 'invoiceNumber,created,orderLineItems,orderProofs,orderShippingOptions,orderPayments,cachedTotal,cachedPaid,cachedBalance,cachedTotalSansTax,orderStatusID',
    //             'p': pl.CurrentPage(),
    //             'q': pl.Search(),
    //         },
    //     }).then(resp => { console.log(resp); return resp; }),
    // });

    await axios.get<hyejoo.Orders>('/orders', {
        params: {
            'sort': 'created desc',
            'max': 1,
        },
    }).then(resp => {
        const latestOrder = resp.data.orders[0];

        if (!latestOrder) {
            const hasLatestOrder = document.querySelector('#has-latest-order') as HTMLElement;
            const noLatestOrder = document.querySelector('#no-latest-order') as HTMLElement;

            hasLatestOrder.classList.add('d-none');
            noLatestOrder.classList.remove('d-none');
            return;
        }

        if (latestOrder.invoiceNumber) {
            const orderNumber = document.querySelector('#order-number') as HTMLElement;
            orderNumber.textContent = latestOrder.invoiceNumber.toString();
        }

        if (latestOrder.created) {
            const orderDate = document.querySelector('#order-date') as HTMLElement;
            orderDate.textContent = DateTime.fromISO(latestOrder.created || '').toLocaleString(DateTime.DATE_SHORT);
        }

        if (latestOrder.orderPayments?.length) {
            const orderPaymentMethod = document.querySelector('#order-payment-method') as HTMLElement;
            if (latestOrder.orderPayments.length > 1) {
                orderPaymentMethod.textContent = 'Multiple Methods';
            } else {
                const singleOrderPaymentOption = latestOrder.orderPayments[0].paymentOption;
                const bankOrCredit = singleOrderPaymentOption?.paymentOptionType?.id === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK || singleOrderPaymentOption?.paymentOptionType?.id === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT;
                orderPaymentMethod.textContent = bankOrCredit ? `${singleOrderPaymentOption?.paymentOptionType?.name || ''} ending in ${singleOrderPaymentOption.creditCardLast4 || '****'}` : singleOrderPaymentOption?.paymentOptionType?.name || '';
            }
        }

        const proofImgTag = document.querySelector('#latest-order-thumbnail') as HTMLImageElement;
        const proofAnchorTag = document.querySelector('#latest-proof-anchor') as HTMLAnchorElement;
        if (latestOrder.orderProofs?.length) {
            const latestOrderProof = latestOrder.orderProofs[0];
            if (latestOrderProof) {
                if (latestOrderProof.proof?.main) {
                    proofAnchorTag.href = latestOrderProof.proof?.main;
                }
                if (latestOrderProof.proof?.name) {
                    proofAnchorTag.dataset.caption = `Proof ${latestOrderProof.proof?.name || ''}`;
                }
                if (latestOrderProof.proof?.thumbnail) {
                    proofImgTag.src = latestOrderProof.proof.thumbnail;
                }
            }
        }

        const viewOrderDetailsBtn = document.querySelector('#view-order-details-btn') as HTMLButtonElement;
        viewOrderDetailsBtn.addEventListener('click', () => {
            window.location.href = `${Relref('/orders/track')}?id=${latestOrder.key || ''}`;
        });
    });

    const name = document.querySelector('#user-first-name') as HTMLElement;
    name.textContent = (await sess).firstName;

    const profileName = document.querySelector('#user-name') as HTMLElement;
    const profileEmail = document.querySelector('#user-email') as HTMLElement;
    profileName.textContent = `${(await sess).firstName} ${(await sess).lastName}`;
    profileEmail.textContent = (await sess).email;

    if ((await sess).phone) {
        const profilePhone = document.querySelector('#user-phone') as HTMLElement;
        profilePhone.classList.remove('d-none');
        const p = Human((await sess).phone);
        profilePhone.textContent = p;
    }

    if ((await sess).company) {
        const profileCompany = document.querySelector('#user-company') as HTMLElement;
        profileCompany.classList.remove('d-none');
        profileCompany.textContent = (await sess).company;
    }

    const $latestShippingContainer = document.querySelector('#latest-shipping-address-container') as HTMLElement;

    const latestShippingOption = await shippingoptions.GetShippingOptions({
        'data': 'fullName,company,addressLine1,addressLine1,city,stateID,zip,countryID,phone,email',
        'sort': 'created desc',
        'max': '1',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    if (!latestShippingOption[0]) {
        $latestShippingContainer.classList.add('d-none');
        if ($latestShippingContainer.nextElementSibling instanceof HTMLHRElement) {
            $latestShippingContainer.nextElementSibling.classList.add('d-none');
        }
    } else {
        $latestShippingContainer.classList.remove('d-none');
        if ($latestShippingContainer.nextElementSibling instanceof HTMLHRElement) {
            $latestShippingContainer.nextElementSibling.classList.remove('d-none');
        }

        const $latestShippingInnerContainer = $latestShippingContainer.querySelector('#latest-shipping-address') as HTMLElement;

        const countryID = await countries.GetCountry(latestShippingOption[0]?.countryID || 0);
        const stateID = await countries.GetState(latestShippingOption[0]?.countryID || 0, latestShippingOption[0]?.stateID || 0);

        const $shippingAddressLine = $latestShippingInnerContainer.querySelector('#address-line') as HTMLElement;
        $shippingAddressLine.textContent = latestShippingOption[0]?.addressLine1 ?? '';
        const $shippingCity = $latestShippingInnerContainer.querySelector('#city') as HTMLElement;
        $shippingCity.textContent = latestShippingOption[0]?.city ? `${latestShippingOption[0].city},` : '';
        const $shippingState = $latestShippingInnerContainer.querySelector('#state') as HTMLElement;
        $shippingState.textContent = stateID?.name ? `${stateID.name},` : '';
        const $shippingZip = $latestShippingInnerContainer.querySelector('#zip') as HTMLElement;
        $shippingZip.textContent = latestShippingOption[0]?.zip ? latestShippingOption[0].zip : '';
        const $shippingCountry = $latestShippingInnerContainer.querySelector('#country') as HTMLElement;
        $shippingCountry.textContent = countryID?.name ?? '';
    }

    $spinner.classList.add('d-none');
    $content.classList.remove('d-none');
}